/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'gatsby';
import { displayNameLimits } from '@data/navigation';
import { adjustStringLength } from '@utils/navigationHelpers';

const FooterNavigationList = ({ links, listClassName }) => (
  <ul className={listClassName}>
    {links.map((item) => (
      <li key={`${item.title}}`}>
        {item.source === 'Internal' ? (
          <Link data-cy="footer-link" to={item.link} title={item.title}>
            {adjustStringLength(item.title, displayNameLimits.footerLinkName)}
          </Link>
        ) : (
          <a
            data-cy="footer-link"
            title={item.title}
            rel={`${item.newTab ? 'noreferrer' : ''}`}
            href={item.link}
            target={`${item.newTab ? '_blank' : '_self'}`}
          >
            {adjustStringLength(item.title, displayNameLimits.footerLinkName)}
          </a>
        )}
      </li>
    ))}
  </ul>
);

FooterNavigationList.defaultProps = {
  listClassName: '',
};

const linkPropType = PropTypes.shape({
  link: PropTypes.string.isRequired,
  newTab: PropTypes.bool,
  source: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
});

FooterNavigationList.propTypes = {
  links: PropTypes.arrayOf(linkPropType).isRequired,
  listClassName: PropTypes.string,
};

export default FooterNavigationList;
